<div class="navbar-scroll-container h-full" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }">
    <div class="navbar-content h-full flex flex-col">
        @if (navigation) {
        <fuse-navigation layout="vertical"></fuse-navigation>
        } @else {
        <div class="space-y-2 ">
            <div class="h-10 bg-gray-200 rounded-lg animate-pulse"></div>
            <div class="h-10 bg-gray-200 rounded-lg animate-pulse"></div>
        </div>
        }
    </div>
</div>